module.exports = __webpack_public_path__ + "media/site/images/products/saas_ceodash-screen3@2x-3f11ceb5ff9f2006c95caf47d8e728bd.png";